export default __webpack_public_path__ + "images/redash_icon_small.png";